<template>
    <div class="w-full bg-dark-gray flex flex-col justify-center h-16">
       <div class="flex flex-row container mx-auto justify-between">
           <div class="ml-5 lg:ml-0 flex-row items-center hidden lg:block">
               <div class="">
                   <span class="text-white font-sans font-bold text-xl mr-1">Arkar</span><span class="text-text-gray font-sans font-bold text-xl">Mann Aung</span>
               </div>
               
           </div>
           <div class="ml-5 lg:ml-0 flex flex-row items-center">
                <div class="text-text-gray font-sans text-sm ">
                    © 2022. All Rights Reserved
                </div>
            </div>
           <div class="mr-5 lg:mr-0 flex flex-row items-center">
               <a class="ml-3 lg:ml-8 text-white" href="https://github.com/arkarMannAung">
                    <i class="fa-brands fa-github text-2xl"></i>
               </a>
               <a class="ml-3 lg:ml-8" href="https://www.facebook.com/arkarmannaung">
                   <i class="fa-brands fa-facebook text-2xl text-white"></i>
               </a>
               <a class="ml-3 lg:ml-8" href="https://t.me/arkarmannaung">
                   <i class="fa-brands fa-telegram text-2xl text-white"></i>
               </a>
           </div>
       </div>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>